module.exports = __webpack_public_path__ + "static/media/warp.c6fae677.svg";